import React, { useState } from 'react';
import CouponPopup from './CouponPopup';

const CouponPopupDemo = () => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-gray-800 dark:text-gray-100">
          Coupon Popup Demo
        </h1>
        
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-200">
            Test the Coupon Popup
          </h2>
          
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            Click the button below to show the coupon popup. In production, this popup would appear
            automatically when a user visits the site, based on the logic in the useCouponPopup hook.
          </p>
          
          <button
            onClick={() => setShowPopup(true)}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          >
            Show Coupon Popup
          </button>
        </div>
        
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4 text-gray-700 dark:text-gray-200">
            Implementation Details
          </h2>
          
          <div className="prose dark:prose-invert">
            <h3>Features</h3>
            <ul>
              <li>Modern glassmorphism design with gradient accents</li>
              <li>Live countdown timer showing hours, minutes, and seconds</li>
              <li>Responsive layout that works on all screen sizes</li>
              <li>Dark mode support</li>
              <li>Non-intrusive close button</li>
              <li>Local storage integration to prevent showing too frequently</li>
            </ul>
            
            <h3>Technical Implementation</h3>
            <ul>
              <li>React component with hooks for state management</li>
              <li>Tailwind CSS for styling</li>
              <li>Custom hook (useCouponPopup) for controlling display logic</li>
              <li>localStorage for persistence between sessions</li>
            </ul>
          </div>
        </div>
      </div>
      
      {showPopup && <CouponPopup onClose={() => setShowPopup(false)} />}
    </div>
  );
};

export default CouponPopupDemo; 